<template>
  <BasePopup
    class="popup-tmpl bg-white py-10 px-10"
    :fixed="true"
    :preventScroll="true"
    v-on="$listeners"
  >
    <BaseButton
      size="none"
      variant="none"
      class="close-btn bg-white text-trueBlue px-3 py-3"
      @click="$emit('close')"
    >
      <BaseIcon name="close" width="21" height="21" />
    </BaseButton>
    <slot></slot>
  </BasePopup>
</template>

<script>
  import BasePopup from '@/components/global/base-popup';
  import BaseIcon from '@/components/global/base-icon/index';
  import BaseButton from '@/components/global/base-button/index';

  export default {
    name: 'PopupTemplate',

    components: {
      BaseIcon,
      BasePopup,
      BaseButton,
    },
  };
</script>

<style lang="scss" scoped>
  .popup-tmpl {
    .close-btn {
      position: absolute;
      top: rem(0px);
      right: rem(-68px);
      border-radius: rem(0px);
    }
  }
</style>
